import {Component} from '@angular/core';
import {ThemingService} from "../../../theming.service";
import {BehaviorSubject} from "rxjs";
import {ThemeConfig} from "../../../theme-config";

@Component({
    selector   : 'footer',
    templateUrl: './footer.component.html',
    styleUrls  : ['./footer.component.scss']
})
export class FooterComponent
{
    public theme: BehaviorSubject<ThemeConfig>;
    version: string =  require('../../../../../package.json').version;;
    /**
     * Constructor
     */
    constructor(
      private themeService: ThemingService,
    )
    {
        this.theme = this.themeService.currentTheme;
    }
}
